module.exports = __webpack_public_path__ + "media/whale sharks/whale_swim-4480c831.jpg";